export const ActionTypes = {
    GET_PLANS_REQUEST: 'GET_PLANS_REQUEST',
    GET_PLANS_SUCCESS: 'GET_PLANS_SUCCESS',
    GET_PLANS_FAILURE: 'GET_PLANS_FAILURE'
}
